module.exports = {
  messages: {
    CN: {
      'freightsetting.tip': '温馨提示',
      'freightsetting.description': '1、运费为0时，表示免运费',
      'freightsetting.description2': '2、运费不为0的情况下，如果不需要免运费，免运费规则请输入0或者留空。',
      'freightsetting.importdata': '导入数据',
      'freightsetting.runall': '全部启用',
      'freightsetting.stopall': '全部停用',
      'freightsetting.freerules': '免运费规则',
      'freightsetting.sendmoney': '运输费用',
      'freightsetting.save': '保存',
      'freightsetting.surecannel': '确定要取消吗？',
      'freightsetting.japanaddress': '区域',
      'freightsetting.chinaaddress': '省/自治区/直辖市',
      'freightsetting.sendDay': '运送时间（天）',
      'freightsetting.sendRules': '运费规则',
      'freightsetting.orderMoney': '订单金额达到多少可免运费',
      'freightsetting.importOk': '导入成功',
      'freightsetting.sureImport': '确定导入基础数据覆盖未填写的输入项吗？',
      'freightsetting.sureRunAll': '确定要全部启用吗？',
      'freightsetting.sureStopAll': '确定要全部停用吗？',
      'freightsetting.containTax': '（含税）',
      'freightsetting.sendmoneyNoNull': '运输费用必须大于0'
    },
    JP: {
      'freightsetting.tip': 'ヒント',
      'freightsetting.description': '1、运费为0时，表示免运费',
      'freightsetting.description2': '2、运费不为0的情况下，如果不需要免运费，免运费规则请输入0或者留空。',
      'freightsetting.importdata': '导入数据',
      'freightsetting.runall': '全部启用',
      'freightsetting.stopall': '全部停用',
      'freightsetting.freerules': '免运费规则',
      'freightsetting.sendmoney': '运输费用',
      'freightsetting.save': '保存',
      'freightsetting.surecannel': '确定要取消吗？',
      'freightsetting.japanaddress': 'エリア',
      'freightsetting.chinaaddress': '省/自治区/直辖市',
      'freightsetting.sendDay': '配達日数',
      'freightsetting.sendRules': '运费规则',
      'freightsetting.orderMoney': '订单金额达到多少可免运费',
      'freightsetting.importOk': 'インポート成功',
      'freightsetting.sureImport': '确定导入基础数据覆盖未填写的输入项吗？',
      'freightsetting.sureRunAll': '确定要全部启用吗？',
      'freightsetting.sureStopAll': '确定要全部停用吗？',
      'freightsetting.containTax': '（税込）',
      'freightsetting.sendmoneyNoNull': '运输费用必须大于0'
    }
  }
};